@if (shouldDisplay()) {
  <div class="subscription-container" [class.trial]="isTrial()" [class.active]="isActive()">
    <div class="subscription-info">
      <span class="subscription-label body-small">{{ displayText() }}</span>
      <span class="body-small"
        ><span class="days-value">{{ daysRemaining() }}</span> days</span
      >
    </div>
    <mat-progress-bar mode="determinate" [value]="progressPercentage()"> </mat-progress-bar>
  </div>
}
